var _rect, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 267,
    viewBox: "0 0 268 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 267,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    transform: "translate(-53 -263)",
    fill: "url(#paint0_linear_0_1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -25,
    width: 324,
    height: 324,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -27.5,
    y: -24.5,
    width: 323,
    height: 323,
    rx: 19.5,
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5532 -0.0106506V88.2447H0.436157V89.2447H89.5532V177.862H0.436157V178.862H89.5532V267.117H90.5532V178.862H179.17V267.117H180.17V178.862H267.564V177.862H180.17V89.2447H267.564V88.2447H180.17V-0.0106506H179.17V88.2447H90.5532V-0.0106506H89.5532ZM179.17 177.862V89.2447H90.5532V177.862H179.17Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5532 88.2447V88.7447H90.0532V88.2447H89.5532ZM89.5532 -0.0106506V-0.510651H89.0532V-0.0106506H89.5532ZM0.436157 88.2447V87.7447H-0.0638428V88.2447H0.436157ZM0.436157 89.2447H-0.0638428V89.7447H0.436157V89.2447ZM89.5532 89.2447H90.0532V88.7447H89.5532V89.2447ZM89.5532 177.862V178.362H90.0532V177.862H89.5532ZM0.436157 177.862V177.362H-0.0638428V177.862H0.436157ZM0.436157 178.862H-0.0638428V179.362H0.436157V178.862ZM89.5532 178.862H90.0532V178.362H89.5532V178.862ZM89.5532 267.117H89.0532V267.617H89.5532V267.117ZM90.5532 267.117V267.617H91.0532V267.117H90.5532ZM90.5532 178.862V178.362H90.0532V178.862H90.5532ZM179.17 178.862H179.67V178.362H179.17V178.862ZM179.17 267.117H178.67V267.617H179.17V267.117ZM180.17 267.117V267.617H180.67V267.117H180.17ZM180.17 178.862V178.362H179.67V178.862H180.17ZM267.564 178.862V179.362H268.064V178.862H267.564ZM267.564 177.862H268.064V177.362H267.564V177.862ZM180.17 177.862H179.67V178.362H180.17V177.862ZM180.17 89.2447V88.7447H179.67V89.2447H180.17ZM267.564 89.2447V89.7447H268.064V89.2447H267.564ZM267.564 88.2447H268.064V87.7447H267.564V88.2447ZM180.17 88.2447H179.67V88.7447H180.17V88.2447ZM180.17 -0.0106506H180.67V-0.510651H180.17V-0.0106506ZM179.17 -0.0106506V-0.510651H178.67V-0.0106506H179.17ZM179.17 88.2447V88.7447H179.67V88.2447H179.17ZM90.5532 88.2447H90.0532V88.7447H90.5532V88.2447ZM90.5532 -0.0106506H91.0532V-0.510651H90.5532V-0.0106506ZM179.17 177.862V178.362H179.67V177.862H179.17ZM179.17 89.2447H179.67V88.7447H179.17V89.2447ZM90.5532 89.2447V88.7447H90.0532V89.2447H90.5532ZM90.5532 177.862H90.0532V178.362H90.5532V177.862ZM90.0532 88.2447V-0.0106506H89.0532V88.2447H90.0532ZM0.436157 88.7447H89.5532V87.7447H0.436157V88.7447ZM0.936157 89.2447V88.2447H-0.0638428V89.2447H0.936157ZM89.5532 88.7447H0.436157V89.7447H89.5532V88.7447ZM90.0532 177.862V89.2447H89.0532V177.862H90.0532ZM0.436157 178.362H89.5532V177.362H0.436157V178.362ZM0.936157 178.862V177.862H-0.0638428V178.862H0.936157ZM89.5532 178.362H0.436157V179.362H89.5532V178.362ZM90.0532 267.117V178.862H89.0532V267.117H90.0532ZM90.5532 266.617H89.5532V267.617H90.5532V266.617ZM90.0532 178.862V267.117H91.0532V178.862H90.0532ZM179.17 178.362H90.5532V179.362H179.17V178.362ZM179.67 267.117V178.862H178.67V267.117H179.67ZM180.17 266.617H179.17V267.617H180.17V266.617ZM179.67 178.862V267.117H180.67V178.862H179.67ZM267.564 178.362H180.17V179.362H267.564V178.362ZM267.064 177.862V178.862H268.064V177.862H267.064ZM180.17 178.362H267.564V177.362H180.17V178.362ZM179.67 89.2447V177.862H180.67V89.2447H179.67ZM267.564 88.7447H180.17V89.7447H267.564V88.7447ZM267.064 88.2447V89.2447H268.064V88.2447H267.064ZM180.17 88.7447H267.564V87.7447H180.17V88.7447ZM179.67 -0.0106506V88.2447H180.67V-0.0106506H179.67ZM179.17 0.489349H180.17V-0.510651H179.17V0.489349ZM179.67 88.2447V-0.0106506H178.67V88.2447H179.67ZM90.5532 88.7447H179.17V87.7447H90.5532V88.7447ZM90.0532 -0.0106506V88.2447H91.0532V-0.0106506H90.0532ZM89.5532 0.489349H90.5532V-0.510651H89.5532V0.489349ZM179.67 177.862V89.2447H178.67V177.862H179.67ZM179.17 88.7447H90.5532V89.7447H179.17V88.7447ZM90.0532 89.2447V177.862H91.0532V89.2447H90.0532ZM90.5532 178.362H179.17V177.362H90.5532V178.362Z",
    fill: "#C1C1C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -38,
    y: -35,
    width: 352,
    height: 352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 0,
    y1: 0,
    x2: 375,
    y2: 667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7BD5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.1715417a72a3e299f6dd372de08f9c17.svg";
export { ForwardRef as ReactComponent };